import * as React from 'react'
import { useNavigate } from 'react-router-dom'

import { Box, Button, Wizard, WizardStep } from '@factorialco/deprecated-design-system'
import { v4 as uuidv4 } from 'uuid'

import Modal from 'modules/core/components/Modal'
import { useEffect } from 'modules/core/hooks/useEffect'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

import { editionStep } from './EditionStep'
import { mapColumnsStep } from './MapColumnsStep'
import { uploadFileStep } from './UploadFileStep'
import { WizardData } from './WizardData'
import { EMPLOYEE_IMPORTER_UUID } from './constants'

const steps = (): WizardStep<WizardData>[] => [uploadFileStep(), mapColumnsStep(), editionStep()]

const ImportProcessWizard = () => {
  const [isAlertVisible, setIsAlertVisible] = React.useState(false)
  const { navigation } = useNavigation()
  const navigate = useNavigate()

  const initialData: WizardData = {
    importerUuid: EMPLOYEE_IMPORTER_UUID,
    importerProcessUuid: uuidv4(),
    mappedFields: [],
  }

  const [wizardData, setWizardData] = React.useState<WizardData>(initialData)

  const handleOnSubmit = () => {
    //do nothing
  }

  const handleOnDataChanged = (newData: WizardData) => {
    setWizardData({ ...wizardData, ...newData })
  }

  const handleOnCloseModal = () => {
    setIsAlertVisible(false)
  }

  const handleOnExit = () => {
    track(trackingEvents.importEmployees.closeEmployeesImporter)
    navigate(navigation.employees.list.fullPath())
  }

  useEffect(() => {
    track(trackingEvents.importEmployees.startEmployeesImporter)
  }, [])

  return (
    <ResponsivePage.Body showHeader={false} variant="fullscreen">
      <Box padding="s24" height="full">
        <Wizard.Base
          responsive
          steps={steps()}
          initialData={wizardData}
          onSubmit={handleOnSubmit}
          onDataChanged={handleOnDataChanged}
          bottomSpacing={false}
          resetSteps={wizardData.resetSteps}
          hideHeader
        />
        {isAlertVisible && (
          <Modal
            title={i18n.t('importer_process.modal.title')}
            description={i18n.t('importer_process.modal.description')}
            illustration="alert"
            onClose={handleOnCloseModal}
            footer={
              <>
                <Button type="secondary" onClick={handleOnCloseModal}>
                  {i18n.t('common.cancel')}
                </Button>
                <Button type="primary" onClick={handleOnExit}>
                  {i18n.t('common.exit')}
                </Button>
              </>
            }
          />
        )}
      </Box>
    </ResponsivePage.Body>
  )
}

export default ImportProcessWizard
